<template>
    <div class="wrapper outer">
        <div class="wrapper inner">
            <div class="sidebar primary" id="dvSidebarPrimary">
                <PrimarySidebar />
            </div>
            <div class="page">
                <div class="content">
                    <div class="tela-principal">
                        <div class="page-wrapper primary" id="dvPageWrapperPrimary">
                            <section class="section page-body primary special">
                                <div class="page-body-wrapper primary">
                                    <Toolbar />
                                    <div class="wizard">
                                        <section class="section command-list primary">
                                            <section class="section message-list primary" ref="chatContainer" style="position: relative;">
                                                <div v-if="showLoading" class="custom-loader-overlay-fixed">
                                                    <div class="custom-loader">
                                                        <span></span>
                                                        <span></span>
                                                        <span></span>
                                                    </div>
                                                </div>
                                                <div class="message-list-content">
                                                    <div class="content-wrapper primary">
                                                        <div class="wrapper-inner answer" v-for="(log, index) in logOrder" :key="index">
                                                            <div class="content-icon">
                                                                <div class="icon">
                                                                    <img src="assets/images/logo/logo-escolarai-b.svg" />
                                                                </div>
                                                            </div>
                                                            <div class="content-value">
                                                                <div class="value-text">
                                                                    <div class="title">
                                                                        <h3>
                                                                            {{ currentCrewHistory.title }}
                                                                        </h3>
                                                                    </div>
                                                                </div>
                                                                <div class="value-text markdown-content">
                                                                    <p v-if="isJsonString(log.description)" v-html="formatJsonToHtml(log.description)"></p>
                                                                    <p v-else v-html="processMarkdown(log.description)"></p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="message-list-content" v-for="(message, index) in chatMessages" :key="'chat-'+index">
                                                    <div class="content-wrapper primary">
                                                        <div class="wrapper-inner asking">
                                                            <div class="content-text">
                                                                <div class="desc">
                                                                    <p>
                                                                        {{ message }}
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="wrapper-inner answer">
                                                            <div class="content-icon">
                                                                <div class="icon">
                                                                    <img src="assets/images/logo/logo-escolarai-b.svg" />
                                                                </div>
                                                            </div>
                                                            <div class="content-value">
                                                                <div class="value-text">
                                                                    <div class="title">
                                                                        <h3>
                                                                            {{ currentCrew.name }}
                                                                        </h3>
                                                                    </div>
                                                                </div>
                                                                <div class="value-text markdown-content">
                                                                    <p v-html="processMarkdown(replyMessages[index])">
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div ref="scrollAnchor"></div>
                                            </section>
                                        </section>
                                    </div>
                                </div>
                            </section>
                            <section class="section message-box primary">
                                <div class="message-box-content">
                                    <div class="content-form">
                                        <div class="form-group">
                                            <div class="form-input">
                                                <span class="link">
                                                    <a class="link-form" href="#">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                            <path d="M12.2963 2.29489C12.3402 2.20635 12.4079 2.13183 12.4918 2.07972C12.5757 2.02761 12.6725 2 12.7713 2C12.8701 2 12.9669 2.02761 13.0509 2.07972C13.1348 2.13183 13.2025 2.20635 13.2463 2.29489L15.5563 6.97389C15.7085 7.28186 15.9331 7.5483 16.211 7.75035C16.4888 7.95239 16.8115 8.08401 17.1513 8.13389L22.3173 8.88989C22.4152 8.90408 22.5072 8.94537 22.5828 9.00909C22.6585 9.07282 22.7148 9.15644 22.7453 9.2505C22.7759 9.34456 22.7796 9.4453 22.7559 9.54133C22.7322 9.63736 22.6821 9.72485 22.6113 9.79389L18.8753 13.4319C18.6289 13.672 18.4446 13.9684 18.3382 14.2955C18.2317 14.6227 18.2064 14.9708 18.2643 15.3099L19.1463 20.4499C19.1636 20.5477 19.153 20.6485 19.1158 20.7406C19.0786 20.8327 19.0163 20.9125 18.9359 20.9709C18.8555 21.0293 18.7603 21.0639 18.6612 21.0708C18.5621 21.0777 18.463 21.0566 18.3753 21.0099L13.7573 18.5819C13.453 18.4221 13.1145 18.3386 12.7708 18.3386C12.4272 18.3386 12.0886 18.4221 11.7843 18.5819L7.16733 21.0099C7.07966 21.0563 6.98073 21.0772 6.88178 21.0701C6.78284 21.0631 6.68785 21.0285 6.60763 20.9701C6.5274 20.9118 6.46516 20.8321 6.42799 20.7401C6.39081 20.6481 6.38019 20.5476 6.39733 20.4499L7.27833 15.3109C7.33653 14.9716 7.31131 14.6233 7.20487 14.2959C7.09842 13.9686 6.91394 13.672 6.66733 13.4319L2.93133 9.79489C2.85992 9.72593 2.80932 9.63829 2.78529 9.54197C2.76126 9.44565 2.76477 9.34451 2.79541 9.25008C2.82605 9.15566 2.8826 9.07174 2.95861 9.00788C3.03462 8.94402 3.12703 8.90279 3.22533 8.88889L8.39033 8.13389C8.73059 8.08439 9.05372 7.95295 9.33191 7.75088C9.61011 7.54881 9.83503 7.28216 9.98733 6.97389L12.2963 2.29489Z"
                                                                stroke="#FFFFFF"
                                                                stroke-width="2"
                                                                stroke-linecap="round"
                                                                stroke-linejoin="round"
                                                            />
                                                        </svg>
                                                    </a>
                                                </span>
                                                <span class="input">
                                                    <input
                                                        type="search"
                                                        v-model="hasMessage"
                                                        class="form-control"
                                                        placeholder="Escreva a tarefa que precisa ser feita"
                                                        @keyup.enter="getReplyRunIa"
                                                    />
                                                </span>
                                                <span class="button">
                                                    <button
                                                        type="button"
                                                        class="btn btn-block btn-form"
                                                        @click="getReplyRunIa"
                                                    >
                                                        <svg
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            width="24"
                                                            height="24"
                                                            viewBox="0 0 24 24"
                                                            fill="none"
                                                        >
                                                            <path
                                                                fill-rule="evenodd"
                                                                clip-rule="evenodd"
                                                                d="M4.79495 5.12264C3.06804 4.50448 1.48934 6.34298 2.36147 7.95659L4.91684 12.6845L2.45796 16.9331C1.53522 18.5274 3.07596 20.4157 4.82302 19.8317L20.5763 14.5658C22.3773 13.9637 22.4041 11.4259 20.6163 10.7859L4.79495 5.12264ZM17.2389 11.7012L4.12092 7.00564L6.65881 11.7012H17.2389ZM6.63923 13.7012L4.18895 17.9349L16.854 13.7012H6.63923Z"
                                                                fill="white"
                                                            />
                                                        </svg>
                                                    </button>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="content-caption">
                                        <div class="caption">
                                            <span>
                                                Lembre-se de sempre revisar! Os
                                                textos são gerados por
                                                inteligência artificial e podem
                                                conter informações imprecisas.
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </section>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    /* eslint-disable */
    import PrimarySidebar from '@/components/primarySidebar.vue';
    import { mapState, mapActions } from 'vuex';
    import order from '@/utils/order';
    import Toolbar from '@/components/toolbarHeader.vue';

    export default {
        components: {
            PrimarySidebar,
            Toolbar
        },
        data() {
            return {
                hasMessage: '',
                responseRunIa: [],
                logOrder: [],
                showLoading: false,
                chatMessages: [],
                replyMessages: []
            };
        },
        computed: {
            ...mapState(['token', 'user', 'currentCrew', 'currentRunIa', 'userInfoData', 'currentCrewHistory', 'ordersHistory'])
        },
        mounted() {
            this.historyOrders();
        },
        watch: {
            replyMessages(newVal, oldVal) {
                this.$nextTick(() => {
                    this.scrollToBottom();
                });
            },
            logOrder(newVal, oldVal) {
                this.$nextTick(() => {
                    this.scrollToBottom();
                });
            },
            currentCrewHistory: {
                handler(newVal, oldVal) {
                    this.historyOrders();
                },
                deep: true
            },
            currentCrew(newVal, oldVal) {
                // Chama o loader quando currentCrew alterar
                this.showLoading = true;
            }
        },
        methods: {
            ...mapActions(['getCrews', 'storeIsVisibleSideBarGenericModal', 'storeFieldsModalGeneric', 'storeCurrentCrew', 'storeUserInfoData', 'storeIsVisibleModalUser', 'storeCrewsList', 'storeOrdersHistory']),
            processMarkdown(text) {
                if (!text) return '';
                text = text.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>');
                text = text.replace(/\n/g, '<br>');
                return text;
            },
            isJsonString(str) {
                try {
                    JSON.parse(str.replace(/'/g, '"'));
                    return true;
                } catch (e) {
                    return false;
                }
            },
            formatJsonToHtml(jsonStr) {
                try {
                    const data = JSON.parse(jsonStr.replace(/'/g, '"'));
                    let html = '<div class="json-content">';
                    for (const [key, value] of Object.entries(data)) {
                        html += `<p><strong>${key.replace(/_/g, ' ').toUpperCase()}:</strong> ${value}</p>`;
                    }
                    html += '</div>';
                    return html;
                } catch (e) {
                    return jsonStr;
                }
            },
            async historyOrders() {
                this.showLoading = true;
                const id = this.$route.params.slug;
                try {
                    const response = await order.getOrderLogs(id, this.token);
                    this.logOrder = response;
                    this.showLoading = false;
                    this.$nextTick(() => {
                        this.scrollToBottom();
                    });
                } catch (error) {
                    console.error('Erro ao buscar resposta da IA:', error);
                    this.showLoading = false;
                }
            },
            async getReplyRunIa() {
                if (!this.hasMessage) return;
                this.showLoading = true;
                this.chatMessages.push(this.hasMessage);
                const message = this.hasMessage;
                this.hasMessage = '';
                await this.$nextTick();
                this.scrollToBottom();
                const payload = {
                    "id": this.currentCrewHistory.id,
                    "type_engine": 1,
                    "crew_id": this.currentCrewHistory.crew_id,
                    "request_type": 1,
                    "status": 0,
                    "parameters": [
                        {
                            "type": 1,
                            "property": "request",
                            "value": message
                        }
                    ]
                };
                try {
                    const response = await order.order(payload, this.token);
                    this.replyMessages.push(response?.output ?? '');
                    this.showLoading = false;
                    this.$nextTick(() => {
                        this.scrollToBottom();
                    });
                } catch (error) {
                    console.error('Erro ao buscar resposta da IA:', error);
                    this.showLoading = false;
                }
            },
            scrollToBottom() {
                this.$nextTick(() => {
                    const anchor = this.$refs.scrollAnchor;
                    if (anchor && typeof anchor.scrollIntoView === 'function') {
                        anchor.scrollIntoView({ behavior: 'smooth', block: 'end' });
                    }
                });
            }
        },
    }
</script>

<style lang="scss" scoped></style>
<style scoped>
/* Corrigido: loader overlay agora cobre corretamente a área da lista de mensagens */
.custom-loader-overlay-fixed {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(30, 30, 30, 0.7);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999;
    pointer-events: all;
}

.custom-loader {
    display: flex;
    gap: 10px;
}
.custom-loader span {
    width: 16px;
    height: 16px;
    background: #4FCCEA;
    border-radius: 50%;
    display: inline-block;
    animation: custom-bounce 1.2s infinite;
}
.custom-loader span:nth-child(2) {
    animation-delay: 0.2s;
}
.custom-loader span:nth-child(3) {
    animation-delay: 0.4s;
}
@keyframes custom-bounce {
    0%, 80%, 100% {
        transform: scale(0.7);
        opacity: 0.7;
    }
    40% {
        transform: scale(1.2);
        opacity: 1;
    }
}
.value-text p {
    color: white;
}
.markdown-content {
    color: white;
}
.markdown-content strong {
    font-weight: bold;
}
.json-content p {
    margin: 5px 0;
}
/* Removendo a barra de scroll do chat-container */
.chat-container {
    height: calc(100vh - 200px);
    overflow-y: hidden !important;
    display: flex;
    flex-direction: column;
}
.section.page-body.primary.special {
    /* Remove a barra de scroll desse elemento */
    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none; /* IE e Edge */
}
.section.page-body.primary.special::-webkit-scrollbar {
    display: none; /* Chrome, Safari e Opera */
}
</style>